<template lang="pug">
.checkin-modal-container(v-if="show", @touchmove.prevent)
  .container
    .top-block
      .top-close
        .top-close-btn(@click="closeMoal")
          img(src="https://m.hellobike.com/resource/helloyun/08345/nEFYzuxKIh.png?x-oss-process=image/quality,q_80")
      .top-title {{windowData.mainTitle}}
      .top-info {{windowData.subTitle}}
      .top-btn
        .top-red-btn(@click="submit(windowData)") {{windowData.buttonText}}
    .image-block
      div(v-if="windowData.suffix === 'json'")
        Lottie.lottie(:url="imgUrl")
      div(v-else)
        img.block(:src="imgUrl")
  .shadow
</template>

<script>
import Lottie from '@/components/lottie';
import { env, Native } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { prizeAward } from '@/api/collect-coupons';
import Toast from '@/components/toast';
import { getTokenAndLocation } from '../../../../utils';
import { getVersion, getSystemCode } from '../../../../utils/systemCode';
// import PrizeCodeItem from './prize-code-item.vue';
// "https://assets.51downapp.cn/4508fbe776a648ea915d3e2c06d12084"
export default {
  components: {
    Lottie,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    windowData: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      title: '',
      row1: [],
      row2: [],
      allreadyList: [],
      imgUrl: '',
    };
  },
  watch: {
    windowData(val) {
      this.imgUrl = val.backgroudUrl;
    },
  },
  methods: {
    async submit(item) {
      UBT.clickButton({
        pageId: 'platform_appmarketing',
        buttonName: 'platform_immersive',
        categoryId: 'platform',
        businessInfo: {
          activityname: item.mainTitle,
        },
      });
      if (item.windowActivityType === 1) {
        this.close(1);
      } else if (item.windowActivityType === 2) {
        const data = await getTokenAndLocation();
        const {
          token, adCode, cityCode,
        } = data;
        const parmas = {
          token,
          activityCode: item.activityCode,
          adCode,
          cityCode,
          systemCode: getSystemCode(),
          version: await getVersion(),
        };
        try {
          const res = await prizeAward(parmas);
          if (res.data && res.data.status === 2) {
            Toast.show('领取成功');
          } else {
            Toast.show('领取失败');
          }
          setTimeout(() => {
            this.close();
          }, 1000);
        } catch (ex) {
          Toast.showError(ex);
        }
      } else {
        let channel = 'app';
        if (env.isAliMP || env.isAliMPMonitor) {
          channel = 'ali';
        }
        if (channel === 'ali') {
          await Native.callNative({
            method: 'goOperationUrlV2',
            params: item.targetUrl,
          });
        } else {
          window.location.href = item.targetUrl;
        }
        this.$emit('close');
      }
    },
    status() {
      this.$emit('close');
      this.$emit('update:show', false);
    },
    close(value) {
      if (value) {
        this.$emit('show-buy');
      }
      this.status();
    },
    closeMoal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.checkin-modal-container {
  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.92);
    z-index: 100;
  }

  .light {
    z-index: 109;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 1.59rem;
    width: 2.47rem;
  }

  .container {
    position: fixed;
    width: 100%;
    left: 50%;
    top: 0;
    transform: translate(-50%, 0);
    z-index: 110;
  }

  .top-block {
    padding-top: 0.77rem;
    padding-left: 0.24rem;
    padding-right: 0.24rem;

    .top-close {
      display: flex;
      justify-content: flex-end;

      .top-close-btn {
        width: 0.32rem;
        height: 0.32rem;

        img {
          width: 0.32rem;
          height: 0.32rem;
        }
      }
    }

    .top-title {
      margin-top: 0.44rem;
      text-align: center;
      font-size: 0.32rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #fff;
      line-height: 0.45rem;
    }

    .top-info {
      margin-top: 0.14rem;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #fff;
      line-height: 22px;
      text-align: center;
    }

    .top-btn {
      display: flex;
      justify-content: center;
      margin-top: 0.24rem;

      .top-red-btn {
        width: 2.27rem;
        height: 0.42rem;
        background: linear-gradient(110deg, #ff5e63 0%, #ff2a3f 100%);
        border-radius: 0.08rem;
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        line-height: 0.16rem;
        color: #fff;
        justify-content: center;
        text-align: center;
        padding-top: 0.13rem;
      }
    }
  }

  .image-block {
    width: 100%;
    margin-top: 0.77rem;

    .lottie {
      width: 100%;
    }

    img.block {
      width: 100%;
      height: 3.13rem;
    }
  }
}
</style>
